// home banner js slider start



$(document).ready(function(){
  $('.banner-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});



// Wholesale Collection Slider JS Start

$('.featured-wholesale-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  speed: 600,
  autoplay: true,
  arrows: true,
  dots: false,
  prevArrow: $('.wholesale-prev'),
  nextArrow: $('.wholesale-next'),
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

jQuery(document).ready(function($){
 
    var step = 100;

 

$(".prev_trigger_btn").on("click", function(event) {
    event.preventDefault();

 

    $(this)
        .closest(".next_prev_btns")
        .prev("div")
        .animate({
            scrollLeft: "-=" + step + "px"
        });
});

 

$(".next_trigger_btn").on("click", function(event) {
    event.preventDefault();

 

    $(this)
        .closest(".next_prev_btns")
        .prev("div")
        .animate({
            scrollLeft: "+=" + step + "px"
        });
});
 
});
